/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import VuePageTitle from "vue-page-title";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
//import "./registerServiceWorker";
import LoadScript from "vue-plugin-load-script";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(LoadScript);
Vue.use(VuePageTitle, { router });
Vue.config.productionTip = false;
Vue.use(Argon);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
